const configurations = {
  dictionary: {
    messages: {
      _default: (field) => `Esse campo não é válido.`,
      validCpf: (field) => 'Esse CPF não é válido.',
      validCnpj: (field) => 'Esse CNPJ não é válido.',
      dataValida: (field) => `Esse campo precisa ser uma data válida (DD/MM/YYYY).`,
      telefoneValido: (field) => `Esse campo precisa ser um telefone válido.`,
      idadeMaxima: (field) => `Esse campo precisa ser uma data válida (DD/MM/YYYY).`,
      idadeMinima: (field, [idadeMinima]) => `Cadastro não permitido para menores de ${idadeMinima} anos.`,
      cidadeValida: (field) => `Esse campo é obrigatório.`,
      alpha_spaces: (field) => `Esse campo só pode conter letras.`,
      between: (field, [min, max]) => `Esse campo precisa estar entre ${min} e ${max}.`,
      date_format: (field, [format]) => `Esse campo precisa estar no formato ${format}.`,
      digits: (field, [length]) => `Esse campo precisa ser numérico e ter exatamente ${length} dígitos.`,
      email: (field) => `Esse campo precisa ter um e-mail válido.`,
      integer: (field) => `Esse campo precisa ser um número inteiro.`,
      length: (field, [length]) => `Esse campo deve ter ${length} digitos`,
      max: (field, [length]) => `Esse campo não pode ter mais do que ${length} caracteres.`,
      max_value: (field, [max]) => `Esse campo precisa ser ${max} ou menos.`,
      min: (field, [length]) => `Esse campo precisa ter pelo menos ${length} caracteres.`,
      min_value: (field, [min]) => `Esse campo precisa ser ${min} ou mais.`,
      numeric: (field) => `Esse campo precisa conter apenas caracteres numéricos.`,
      required: (field) => `Esse campo é obrigatório.`,
      required_if: (field, [target]) => `Esse campo é obrigatório quando campo ${target} tiver esse valor.`,
    },
  },
}

module.exports = { configurations }
